import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RadioButton } from 'crawford-shell';
import { AccordionService } from '../services/accordion.service';
import { ClaimService } from '../../claim.service';
import { BehaviorSubject } from '../../../../../node_modules/rxjs/BehaviorSubject';

@Component({
  selector: 'app-claim-source-search',
  templateUrl: './claim-source-search.component.html',
  styleUrls: ['./claim-source-search.component.scss']
})
export class ClaimSourceSearchComponent implements OnInit {
  public claimDataSourceChanged: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  @Input() public group: FormGroup;
  @Input() public accordionGroupName: string;
  public claimSourceOptions: RadioButton[];

  constructor(
    private claimService: ClaimService,
    private accordionService: AccordionService
  ) {
  }

  ngOnInit() {
    this.claimSourceOptions = this.claimService.claimDataSources.map(x => {
      return {
        label: x.name,
        value: x.code
      };
    });
    // Use the value in the 'defaultValue' parameter of the below method 'addFormControl()' not the 'label'
    this.accordionService.addFormControl(this.accordionGroupName, this.group, 'claimDataSource', 'Current');
    this.accordionService.setAccordionHasChanges(this.accordionGroupName, false);

    this.group.controls['claimDataSource'].valueChanges.subscribe(value => {
      this.claimDataSourceChanged.next(value);
    });
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-list/claim-source-search/claim-source-search.component.ts